import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Switch, Route, Redirect, BrowserRouter as Router } from "react-router-dom";

// Components
import SmsTemplate from "../components/SmsTemplate/SmsTemplate";
import Stores from "../components/Stores/StoresPage";
import Calendar from "../components/Calendar/CalendarPage";
import Suppliers from "../components/Suppliers/SuppliersPage";
import Countries from "../components/Countries/CountriesPage";
import PickupAddresses from "../components/Pickup_Addresses/PickupAddressesPage";
import ListsOfDocuments from "../components/ListsOfDocuments/ListsOfDocuments";
import Users from "../components/Users/UsersPage";
import AcceptedOrders from "../components/orders/accepted_orders/AcceptedOrders";
import PrivateRoute from "../components/common/PrivateRoute";
// import Products from "../components/Products/ProductsPage";
import ProductScreen from "../Pages/products";
import CommentsState from "../components/CommentsStates/commentsStatePage";
import DocumentOption from "../components/documents/options/DocumentOption";
import RivileServices from "../components/rivile_services/RivileServicesPage";
import RivilePvm25 from "../components/rivile_services/RivilePvm25Page";
import RivileStores from "../components/rivile_services/RivileStoresPage";
import Statuses from "../components/statuses/StatusesPage";
import PrestaServices from "../components/PrestaServices/PrestaServices";
import ServiceScreen from "../components/ServicePage/ServiceScreen";
import SuppliersInvoices from "../components/suppliers_invoices/suppliers_invoices";
import AdditionalSupplierCodesScreen from "../Pages/Options/AdditionalSupplierCodesScreen";
import PickupAtTheStoreScreen from "../Pages/Options/bigbox/PickupAtTheStoreScreen";
import CategoriesScreen from "../Pages/Options/CategoriesScreen";
import CategoryAttributeMapPage from "../Pages/Options/CategoryAttributeMapPage";
import AttrMapperPage from "../Pages/Options/AttrMapperPage";
import MoneyRefundsScreen from "../Pages/MoneyRefundsScreen";
import TrRequestScreen from "../Pages/TrRequestScreen";
import TrRequestIdScreen from "../Pages/TrRequestIdScreen";
import { userAdditionalInformation } from "../redux/Actions/authAction";
import NotFound404 from "../Pages/NotFound404";
import AutosysScreen from "../Pages/AutosysScreen";
import AlsoIncomeModuleIdScreen from "../Pages/AlsoIncomeModuleIdScreen";
import AlsoIncomesIndex from "../Pages/AlsoIncomesIndex";
import { updateOrderSockets } from "../redux/Actions/orderAction";
import { createConsumer } from "@rails/actioncable";
import { updateRivileBBSockets } from "../redux/Actions/rivile/BigboxRivileAction";
import {
  exportedDocumentPercentagesAction,
  exportedDocumentAction,
} from "../redux/Actions/exportedDocumentAction";
import { websocketShipmentBulk } from "../redux/Actions/bulk_shipment_action";
import EnergyLabelsPage from "../Pages/EnergyLabelsPage";
import { onlyFiOrders } from "../helpers/OrdersFunctionsGlobal";
import { cableOrderRow } from "../redux/Actions/cable_action";
import DeliveriesShipmentPage from "../Pages/deliveries/shipments";
import DeliveriesManifestPage from "../Pages/deliveries/manifests";
import DeliveriesManagementPage from "../Pages/deliveries/management";
import LostCartScreen from "../Pages/LostCartScreen";
import WarrantyMailsPage from "../Pages/WarrantyMailsPage";
import UserRolesPage from "../Pages/Options/UserRolesPage";
import AvailableMenu from "../Pages/Options/UserRolesPage/components/AvailableMenu";
import Login from "../components/Authorization/Login/Login";
import TechnoramaImumPage from "../Pages/technorama/ImumPage";
import BigBoxImumPage from "../Pages/bigbox/ImumPage";
import { ReturnsPage, TechnoramaPickupUsersPage } from "../Pages";
import FeaturesPage from "../Pages/marketing/Features";
import MarketplaceProductsPage from "../Pages/marketplace/MarketplaceProductsPage";
import MarketplaceRulesPage from "../Pages/marketplace/MarketplaceRulesPage";
import MarketplaceHistoryPage from "../Pages/marketplace/MarketplaceHistoryPage";
import MarketingReviews from "../Pages/marketing/ReviewsPage";
import MarketingReviewEmails from "../Pages/marketing/ReviewEmailsPage";
import XMLFeedGenerationPage from "../Pages/bigbox/XMLFeedGeneration/index";
import PaymentMethodGroupsPage from "../Pages/Options/PaymentMethodGroupsScreen";
import PaymentStatusGroupsPage from "../Pages/Options/PaymentStatusGroupsScreen";
import Descriptions from "../components/technorama/Descriptions/Descriptions";
import Description from "../components/technorama/Descriptions/Description";
import Repricings from "../components/technorama/Repricings/Repricings";
import Repricing from "../components/technorama/Repricings/Repricing";
import Brands from "../components/technorama/Brands/Brands";
import Categories from "../components/technorama/Categories/Categories";
import Leasings from "../components/technorama/Leasings/Leasings";
import VVStockProductsPage from "../Pages/vv_stock/ProductsPage";
import VVStockDocumentsPage from "../Pages/vv_stock/DocumentsPage";
import TechnoramaDocumentsPage from "../Pages/technorama/DocumentsPage";
import DocumentDetailsPage from "../Pages/technorama/DocumentDetailsPage";
import StatisticPage from "../Pages/statistic/StatisticPage";
import WishlistPage from "../Pages/wishlist/WishlistPage";
import ProductVariantRulesPage from "../Pages/products/ProductVariantRulesPage";
import ProductVariantGlobalRulesPage from "../Pages/products/ProductVariantGlobalRulesPage";
import NordrentOrdersPage from "../Pages/nordrent/NordrentOrdersPage";

function AuthenticatedRoutes({ user }) {
  const dispatch = useDispatch();
  const permissions = user.user_role?.permissions || {};

  useEffect(() => {
    if (user?.id) {
      dispatch(userAdditionalInformation());
      console.log("IM IN");
    }
  }, []);

  const webSocketReceivedData = (response) => {
    if (typeof response.order !== "undefined") {
      dispatch(updateOrderSockets(response.order));
    } else if (typeof response.rivile_request !== "undefined") {
      const res = JSON.parse(response.rivile_request);
      dispatch(updateRivileBBSockets(res));
    } else if (response?.type == "additional_information") {
      console.count("WEBSOCKET additional_information");
      dispatch(userAdditionalInformation(response.user_id));
    } else if (response?.type == "AUTOSYS_ORDER_ROW") {
      dispatch(cableOrderRow(response.data));
    }
  };

  useEffect(() => {
    console.log("WEBSOCKET: subscribe");
    const consumer = createConsumer();
    const mainChannel = consumer.subscriptions.create(
      { channel: "MainChannel" },
      {
        connected() {
          console.log("Connected WS!");
        },
        received(data) {
          // console.log("WebSocket: ", data);
          webSocketReceivedData(data);
        },
        webSocketReceivedData: webSocketReceivedData,
      }
    );

    const exportedDocumentChannel = consumer.subscriptions.create(
      {
        channel: "ExportedDocumentChannel",
        user_id: user.id,
      },
      {
        connected() {
          console.log("Connected WS ExportedDocumentChannel");
        },
        received(data) {
          console.log({ data });
          if (!data.exported_document) return;
          if (data.exported_document?.element) {
            return dispatch(
              exportedDocumentPercentagesAction(data.exported_document)
            );
          }
          dispatch(exportedDocumentAction(data.exported_document));
        },
      }
    );
    const bulkShipmentsChannel = consumer.subscriptions.create(
      {
        channel: "BulkShipmentsChannel",
        user_id: user.id,
      },
      {
        connected() {
          console.log("Connected WS BulkShipmentsChannel");
        },
        received(data) {
          console.log("Data call");
          if (!data?.data) return;
          dispatch(websocketShipmentBulk(data.data));
        },
      }
    );
    return () => {
      console.log("WEBSOCKET: unsubscribe");
      mainChannel.unsubscribe();
      exportedDocumentChannel.unsubscribe();
      bulkShipmentsChannel.unsubscribe();
    };
  }, []);

  //

  if (user.user_role?.identifier === "nordrent") {
    return (
      <Router>
        <Switch>
          <PrivateRoute
            exact
            path="/nordrent_orders"
            component={NordrentOrdersPage}
          />
          <Route exact path="*">
            <Redirect to="/nordrent_orders" />
          </Route>
        </Switch>
      </Router>
    );
  }

  if (onlyFiOrders(user.id)) {
    return (
      <Router>
        <Switch>
          <PrivateRoute
            exact
            path="/orders"
            component={AcceptedOrders}
            allowed={["admin", "accounting", "manager"]}
          />
          <PrivateRoute
            exact
            path="/orders/:action"
            component={AcceptedOrders}
            allowed={["admin", "accounting", "manager"]}
          />
          <Route exact path="*" component={NotFound404} />
        </Switch>
      </Router>
    );
  }

  const rebuildTree = () => {
    const componentSetter = (uuid) => {
      switch (uuid) {
        case "orders":
          return AcceptedOrders;
        case "wishlist":
          return WishlistPage;
        case "lost_cart":
          return LostCartScreen;
        case "returns":
          return ReturnsPage;
        case "service/repair":
          return ServiceScreen;
        case "service/repair/new":
          return ServiceScreen;
        case "service/contacts":
          return PrestaServices;
        case "products":
          return ProductScreen;
        case "technorama/tr_request":
          return TrRequestScreen;
        case "technorama/tr_request_id":
          return TrRequestIdScreen;
        case "technorama/pickup_users":
          return TechnoramaPickupUsersPage;
        case "technorama/imum":
          return TechnoramaImumPage;
        case "technorama/goods/brands":
          return Brands;
        case "technorama/goods/categories":
          return Categories;
        case "technorama/goods/leasings":
          return Leasings;
        case "technorama/documents":
          return TechnoramaDocumentsPage;
        case "technorama/documentDetails":
          return DocumentDetailsPage;
        case "technorama/goods/descriptions":
          return Descriptions;
        case "technorama/goods/description":
          return Description;
        case "technorama/goods/repricings":
          return Repricings;
        case "technorama/goods/repricing":
          return Repricing;
        case "documents":
          return ListsOfDocuments;
        case "documents/options":
          return DocumentOption;
        case "deliveries/manifests":
          return DeliveriesManifestPage;
        case "deliveries/shipments":
          return DeliveriesShipmentPage;
        case "deliveries/management":
          return DeliveriesManagementPage;
        case "autosys":
          return AutosysScreen;
        case "pickups/shipments":
          return PickupAtTheStoreScreen;
        case "bigbox/imum":
          return BigBoxImumPage;
        case "energy_labels":
          return EnergyLabelsPage;
        case "xml_feed_generation":
          return XMLFeedGenerationPage;
        case "options/categories":
          return CategoriesScreen;
        case "marketing/category_attribute_map":
          return CategoryAttributeMapPage;
        case "options/attr_mapper":
          return AttrMapperPage;
        case "options/sms-templates":
          return SmsTemplate;
        case "options/stores":
          return Stores;
        case "options/suppliers":
          return Suppliers;
        case "options/countries":
          return Countries;
        case "options/pickup_addresses":
          return PickupAddresses;
        case "options/users":
          return Users;
        case "options/user_roles":
          return UserRolesPage;
        case "options/comments_state":
          return CommentsState;
        case "options/warranty_mails":
          return WarrantyMailsPage;
        case "options/rivile/stores":
          return RivileStores;
        case "options/rivile/services":
          return RivileServices;
        case "options/rivile/pvm":
          return RivilePvm25;
        case "options/statuses":
          return Statuses;
        case "options/additional_supplier_codes":
          return AdditionalSupplierCodesScreen;
        case "options/calendar":
          return Calendar;
        case "options/payment_method_groups":
          return PaymentMethodGroupsPage;
        case "options/payment_status_groups":
          return PaymentStatusGroupsPage;
        case "accounting/refunds":
          return MoneyRefundsScreen;
        case "suppliers-invoices":
          return SuppliersInvoices;
        case "also_income_module":
          return AlsoIncomesIndex;
        case "also_income_module_id":
          return AlsoIncomeModuleIdScreen;
        case "supplier_invoices":
          return SuppliersInvoices;
        case "features":
          return FeaturesPage;
        case "reviews":
          return MarketingReviews;
        case "review_emails":
          return MarketingReviewEmails;
        case "vv_stock_products":
          return VVStockProductsPage;
        case "vv_stock_documents":
          return VVStockDocumentsPage;
        case "marketplace/products":
          return MarketplaceProductsPage;
        case "marketplace/rules":
          return MarketplaceRulesPage;
        case "marketplace/history":
          return MarketplaceHistoryPage;
        case "statistic":
          return StatisticPage;
        case "nordrent_orders":
          return NordrentOrdersPage;
        case "product_variant_rules":
          return ProductVariantRulesPage;
        case "product_variant_global_rules":
          return ProductVariantGlobalRulesPage;
        default:
          return Login;
      }
    };
    const tree = AvailableMenu({}, {});
    const available = [];
    const tree_setter = (arr) => {
      arr.forEach((d) => {
        const its_available = permissions[d.uuid];
        if (!its_available) return;
        if (d.url) {
          available.push({
            uuid: d.uuid,
            title: d.title,
            url: d.url,
            component: componentSetter(d.uuid),
          });
          if (d.action) {
            available.push({
              uuid: d.uuid,
              title: d.title,
              url: d.url + "/:action",
              component: componentSetter(d.uuid),
            });
          }
        }
        if (d.options && d.options.length > 0) {
          return tree_setter(d.options);
        }
      });
    };
    tree_setter(tree);

    return available;
  };

  return (
    <Router>
      <Switch>
        {rebuildTree().map((e) => (
          <PrivateRoute
            key={e.uuid}
            exact
            path={e.url}
            component={e.component}
          />
        ))}
        <Route exact path="*" component={NotFound404} />
      </Switch>
    </Router>
  );
}

export default AuthenticatedRoutes;
